import { render } from "./ModalRecepcion.vue?vue&type=template&id=550f16d8"
import script from "./ModalRecepcion.vue?vue&type=script&lang=js"
export * from "./ModalRecepcion.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__